import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BookOpen, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

// Fiche candidat : envoyer le livret d'accueil (PDF joint) et voir la date du dernier envoi
export const BoutonEnvoiLivret = ({ candidatId }) => {
  const [envoye, setEnvoye] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    axios.get(`/livret-accueil/envois/${candidatId}`).then(({ data }) => setEnvoye(data.envoye_le)).catch(() => {});
  }, [candidatId]);

  const envoyer = async () => {
    if (!window.confirm(envoye ? "Renvoyer le livret d'accueil par e-mail ?" : "Envoyer le livret d'accueil par e-mail ?")) return;
    setSaving(true);
    try {
      await axios.post('/livret-accueil/envoyer', { candidat_ids: [candidatId] });
      setEnvoye(new Date().toISOString());
      toast.success("Livret d'accueil envoyé");
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Envoi impossible');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Button variant="outline" onClick={envoyer} disabled={saving} className="bg-white/20 hover:bg-white/30 text-white border-white/30" data-testid="btn-envoyer-livret"
      title={envoye ? `Dernier envoi le ${new Date(envoye).toLocaleDateString('fr-FR')}` : "Le livret n'a pas encore été envoyé"}>
      {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <BookOpen className="h-4 w-4 mr-2" />}
      {envoye ? `Livret envoyé le ${new Date(envoye).toLocaleDateString('fr-FR')}` : "Envoyer le livret"}
    </Button>
  );
};
